// AdditionalInformation.js
import { Card, Form, Flex, Select, Input } from "antd";
import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { countries } from "../../../../../../../../shared-components/countries";
import { cities } from "../../../../../../../../shared-components/cities";
import { getAllEmployeeDesignationAction } from "../../../../../../../../store/action/admin/employeeDesignationAction.js";

const AdditionalInformation = () => {
  const dispatch = useDispatch();
  const themeDefault = useSelector((state) => state.themeDefault);
  const form = Form.useFormInstance();
  const selectedCountry = Form.useWatch("country");

  const { getAllEmployeeDesignationInfo: allEmployeeDesignationList } =
    useSelector((state) => state.allEmployeeDesignationList);

  useEffect(() => {
    dispatch(getAllEmployeeDesignationAction());
  }, [dispatch]);

  return (
    <Card bordered title="Additional Information" style={{ height: 338 }}>
      <Flex
        gap={8}
        vertical
        style={{
          borderTop: themeDefault?.info?.newConfig?.cardborder,
          paddingTop: 16,
          marginTop: -16,
        }}>
        <Flex gap={16} wrap="wrap">
          {/* DESIGNATION DROPDOWN */}
          <Form.Item
            name="designationId"
            label="Designation"
            style={{ flex: 1, minWidth: 220, marginBottom: 8 }}>
            <Select
              placeholder="Select Designation"
              options={
                allEmployeeDesignationList?.map((d) => ({
                  label: d?.designationName,
                  value: d?._id,
                })) || []
              }
            />
          </Form.Item>

          {/* Address */}
          <Form.Item
            name="address"
            label="Address"
            style={{ flex: 1, minWidth: 220, marginBottom: 8 }}>
            <Input placeholder="Enter Address" />
          </Form.Item>
        </Flex>

        <Flex gap={16} wrap="wrap">
          {/* Country */}
          <Form.Item
            name="country"
            label="Country"
            style={{ flex: 1, minWidth: 220, marginBottom: 8 }}>
            <Select
              placeholder="Select Country"
              showSearch
              onChange={() => form.setFieldsValue({ city: undefined })}
              filterOption={(input, option) =>
                (option?.label ?? "")
                  .toLowerCase()
                  .includes(input.toLowerCase())
              }
              options={countries.map((c) => ({ value: c, label: c }))}
            />
          </Form.Item>

          {/* City */}
          <Form.Item
            name="city"
            label="City"
            style={{ flex: 1, minWidth: 220, marginBottom: 8 }}>
            <Select
              placeholder="Select City"
              showSearch
              disabled={!selectedCountry}
              filterOption={(input, option) =>
                (option?.label ?? "")
                  .toLowerCase()
                  .includes(input.toLowerCase())
              }
              options={(cities[selectedCountry] || []).map((c) => ({
                value: c,
                label: c,
              }))}
            />
          </Form.Item>

          {/* State */}
          <Form.Item
            name="state"
            label="State/Province"
            style={{ flex: 1, minWidth: 220, marginBottom: 8 }}>
            <Input placeholder="Enter State/Province" />
          </Form.Item>

          {/* Postal Code */}
          <Form.Item
            name="postalCode"
            label="Zip/Postal Code"
            style={{ flex: 1, minWidth: 220, marginBottom: 0 }}>
            <Input placeholder="Enter Zip/Postal Code" />
          </Form.Item>
        </Flex>
      </Flex>
    </Card>
  );
};

export default AdditionalInformation;
